import gql from 'graphql-tag'

export const BLOCK_DELETE = gql`
    mutation blockDelete($blockID: ID!, $website: ID!) {
        blockDelete(blockID: $blockID, website: $website) {
            success
            statusCode
        }
    }
`
